import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { PureFooter } from "./pure-footer";
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews";

const query = graphql`
  query Footer {
    prismicFooter {
      _previewable
      data {
        column_text_1 {
          column_item {
            richText
          }
        }
        column_text_2 {
          column_item {
            richText
          }
        }
        column_text_3 {
          column_item {
            richText
          }
        }
        column_title_1
        column_title_2
        column_title_3
        legal_links {
          legal_link {
            richText
          }
        }
      }
    }
    emissions {
      total_lbs
    }
  }
`;

export default function FooterRender() {
  const staticData = useStaticQuery(query);

  return <PureFooter data={useMergePrismicPreviewData(staticData)} />;
}
